import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  PaymentMethodKind,
  PaymentMethodListResponse,
  TogglePaymentMethodRequest,
} from "@ticketnjoy/types";

import { apiClient } from "@/lib/api-client";

export const paymentMethodsQueryKey = (shopSlug: string) =>
  ["shops", shopSlug, "payment-methods"] as const;

export function useShopPaymentMethodsQuery(shopSlug: string) {
  return useQuery<PaymentMethodListResponse>({
    queryKey: paymentMethodsQueryKey(shopSlug),
    queryFn: () =>
      apiClient<PaymentMethodListResponse>(
        `/shops/${shopSlug}/payment-methods`,
      ),
    enabled: Boolean(shopSlug),
  });
}

interface ToggleVariables {
  kind: PaymentMethodKind;
  isActive: boolean;
}

export function useTogglePaymentMethodMutation(shopSlug: string) {
  const qc = useQueryClient();
  return useMutation<PaymentMethodListResponse, Error, ToggleVariables>({
    mutationFn: ({ kind, isActive }) =>
      apiClient<PaymentMethodListResponse>(
        `/shops/${shopSlug}/payment-methods/${kind}`,
        {
          method: "PATCH",
          body: { isActive } satisfies TogglePaymentMethodRequest,
        },
      ),
    onSuccess: (data) => {
      qc.setQueryData(paymentMethodsQueryKey(shopSlug), data);
    },
  });
}
